"use client";
import { useAuth } from "@/providers/auth-context";
import { SidebarProvider } from "@/providers/sidebar-context";
import Sidebar from "../navigation/sidenav";
import styles from "./app-layout.module.scss";

export default function AppLayout({ children }: any) {
  const { authenticated } = useAuth();
  return (
    <>
      <SidebarProvider>
        <div className={styles.layoutContainer}>
          <div className={styles.layout}>
            {/* {authenticated && <Sidebar />} */}
            <main className={styles.layoutMainContent}>{children}</main>
          </div>
        </div>
      </SidebarProvider>
    </>
  );
}
